import { cloneDeep, merge } from 'lodash'
import { StateCreator } from 'zustand'

import { TAgent } from '~/features/agents/models'
import { getDefaultAgentData } from '~/features/agents/utils'
import { TChatMessage } from '~/features/chatbot/models'
import { defaultChatBotLayout } from '~/features/settings/components/chatBot/utils'
import { TChatbotSettingsLayout } from '~/features/settings/models'
import EStoreStateKeys from '~/models/store'

type TChatbotDefinition = {
  // todo: see maybe we can simplify this, or use the agent from query directly.
  agent: Partial<TAgent>
  layout: TChatbotSettingsLayout
  conversationId: string
  showBookAMeeting: boolean
  messages: TChatMessage[]
}

type TChatbot = {
  [EStoreStateKeys.chatbot]: TChatbotDefinition
}

export type TChatbotState = TChatbot & {
  setChatbot(chatbot: Partial<TChatbotDefinition>): void
  resetChatbot(): void
}

export const initialChatbotState: TChatbotDefinition = {
  agent: getDefaultAgentData(),
  layout: cloneDeep(defaultChatBotLayout),
  conversationId: '',
  showBookAMeeting: false,
  messages: [],
}

const createChatbotSlice: StateCreator<
  TChatbotState,
  [['zustand/devtools', unknown]],
  []
> = (set) => ({
  chatbot: cloneDeep(initialChatbotState),
  setChatbot: (chatbot) =>
    set(
      (state) => ({ chatbot: cloneDeep(merge(state.chatbot, chatbot)) }),
      undefined,
      {
        type: 'setChatbot',
        chatbot,
      },
    ),
  resetChatbot: () =>
    set(() => ({ chatbot: cloneDeep(initialChatbotState) }), undefined, {
      type: 'resetChatbot',
    }),
})

export default createChatbotSlice
